import { connect } from 'react-redux';
import { getLocationDetailsById, getDirections, getLocations, getNearest, resetPage, resetMeta } from '../../../actions/DirectionsPage';
import { getBuildingFloorGeojson, getBuildingFloorNavNodes, getLocationBuildingFloorsById } from '../../../actions/LocationDetailPage';
import DirectionsPage from './DirectionsPage';

const mapsStateToProps = state => ({
	pageProps: state.locationDetailPage.directionsPageReducer,
	locationDetailPageProps: state.locationDetailPage.locationDetailPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getLocationDetailsById(options) {
		dispatch(getLocationDetailsById(options));
	},
	getBuildingFloorGeojson(options) {
		dispatch(getBuildingFloorGeojson(options));
	},
	getLocationBuildingFloorsById(options) {
		dispatch(getLocationBuildingFloorsById(options));
	},
	getLocations(options) {
		dispatch(getLocations(options));
	},
	getNearest(options) {
		dispatch(getNearest(options));
	},
	getBuildingFloorNavNodes(options) {
		dispatch(getBuildingFloorNavNodes(options));
	},
	getDirections(options) {
		dispatch(getDirections(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(DirectionsPage);